import {
  useGetItemById,
  useGetItemPublic,
  useGetListItems,
  useMutateItem,
  useGetItem as useGetItemGeneric,
} from '../../../hooks/entityMethodsHook'
import { getEndDateTime, getStartDateTime } from '../../../lib/workTime'

export const useGetItems = (queryKey: string, id: string | undefined) => {
  const uri = `time-materials?projectId=${id}`
  return useGetListItems(queryKey, uri)
}

export const useGetItem = (queryKey: string, id: string | undefined) => {
  const uri = `time-materials/${id}?populate=project`
  //return useGetItemById(queryKey, uri, id)
  return useGetItemPublic(queryKey, uri, !!id)
}

export const useMutateCreateTimeMaterial = (
  key: string,
  projectId: string | undefined
) => {
  const uri = `projects/${projectId}/time-materials`
  return useMutateItem(key, uri)
}

export const useMutateCreateTimeMaterialReport = (
  key: string,
  projectId: string | undefined,
  tmId: string | undefined
) => {
  const uri = `projects/${projectId}/time-materials/${tmId}/report`
  return useMutateItem(key, uri)
}

export const useGetTMItem = (queryKey: string, id: string | undefined) => {
  const uri = `time-materials/${id}?populate=project`
  return useGetItemById(queryKey, uri, id)
}

export const useGetTNMItems = (queryKey: string, id: string | undefined) => {
  const uri = `projects/${id}/time-materials`
  return useGetListItems(queryKey, uri)
}

export const useGetTNMReports = (queryKey: string, id: string | undefined) => {
  const uri = `time-materials/${id}/reports`
  return useGetListItems(queryKey, uri)
}

// TODO: clean up so there aren't so many params, rather include the params in the payload body.
export const useGetTimeMaterialReportFormTimeSheets = (
  key: string,
  projectId: any | undefined,
  tmId: any | undefined,
  date: any | undefined
) => {
  const startDate = getStartDateTime(date)
  const endDate = getEndDateTime(date)
  const urlEncodedStartDate = encodeURIComponent(startDate)
  const urlEncodedEndDate = encodeURIComponent(endDate)

  const uri = `timecards/project/${projectId}/time-and-materials/${tmId}?startDate=${urlEncodedStartDate}&endDate=${urlEncodedEndDate}`
  return useGetItemGeneric(key, uri, projectId)
}

export const useGetTimeMaterialReportFormData = (
  key: string,
  projectId: any | undefined,
  tmId: any | undefined,
  tmrId: any | undefined
) => {
  let uri = `projects/${projectId}/time-material-data/${tmId}/report-data`
  if (tmrId) {
    uri += `/${tmrId}`
  }
  return useGetItemGeneric(key, uri, projectId)
}

export const useGetTimeInMaterialReport = (
  key: string,
  id: any | undefined
) => {
  let uri = `time-materials/report/${id}`
  return useGetItemGeneric(key, uri, id)
}
